export function isNerdOf() {
    const host = window.location.host;
    const parts = host.split(".");
    if(host.indexOf("vknows")>-1){
      return false
    } else if(host.indexOf("clsedo")>-1){
      return false
    } else {
      return true
    }
}

export function isVKNOWS() {
    const host = window.location.host;
    const parts = host.split(".");
    if(host.indexOf("vknows")>-1){
      return true
    } else {
      return false
    }
}

export function isClsedo() {
  const host = window.location.host;
  const parts = host.split(".");
  if(host.indexOf("clsedo")>-1){
    return true
  } else {
    return false
  }
}
